import { useTranslation } from 'react-i18next';
import { Card } from '../ui/Card.jsx';

/**
 * SurveyStatsCards — 名單頁上方統計區
 *
 *   受訪人 | 已答題 sessions | 完整答完 | 平均答題 (out of total)
 *
 * 不放 campaign 才有的指標（接通率/撥打次數）— 那些在 Campaign tab。
 */
export function SurveyStatsCards({ stats }) {
    const { t } = useTranslation('survey');
    if (!stats) return null;
    const totalQ = stats.totalQuestions || 0;
    const avgCov = stats.avgCoverage ?? 0;
    const avgPct = totalQ > 0 ? Math.round((avgCov / totalQ) * 100) : 0;
    const items = [
        { label: t('stats.respondents'), value: stats.total ?? 0, sub: t('stats.respondentsSub') },
        { label: t('stats.answeredSessions'), value: stats.totalSessions ?? 0, sub: t('stats.answeredSessionsSub') },
        { label: t('stats.completed'), value: `${stats.completed ?? 0}`, sub: t('stats.completionRateSub', { rate: stats.completionRate ?? 0 }) },
        { label: t('stats.answerRate'), value: `${avgPct}%`, sub: '' },
    ];
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
            {items.map((it, i) => (
                <Card key={i} padded={false}>
                    <div className="px-4 py-3">
                        <div className="mono-caption text-ink-400">{it.label}</div>
                        <div className="mt-1 text-xl font-semibold text-ink-900 tnum">{it.value}</div>
                        <div className="mt-0.5 text-[11px] text-ink-400">{it.sub}</div>
                    </div>
                </Card>
            ))}
        </div>
    );
}
